<template>
<div>
    <div class="datatable-top-bar filters-loop-wrapper col-sm-12">
        <template v-for="(filter, index) in filterComputed">

            <drop-down-filter
                v-if="filter.type === 'drop-down-filter'"
                :key="'drop-down-filter'+index"
                :filter-key="filter.key"
                :id="`${filter.key}-${tableId}`"
                :table-id="tableId"
                :list="filter.option"
                :label="filter.title"
                :list-value-field="filter.listValueField"
                :active="filter.active"
                @get-value="store"
            />

            <dropdown-menu-filter
                v-if="filter.type === 'dropdown-menu-filter'"
                :key="'dropdown-menu-filter'+index"
                :filter-key="filter.key"
                :table-id="tableId"
                :list="filter.option"
                :label="filter.title"
                :active="filter.active"
                :list-value-field="filter.listValueField"
                @get-value="store"
            />

            <app-timeline-filter
                v-if="filter.type === 'timeline-filter'"
                :key="'timeline-filter'+index"
                :table-id="tableId"
                :filter-key="filter.key"
                :filter-option="filter.option"
                :active="filter.active"
                :timeline-candidates="timelineCandidates"
                :timeline-states="timelineStates"
                @get-value="store"
            />



        </template>

    </div>



    

</div>
</template>


<script>
import DropDownFilter from "./DropDownFilter";
import coreLibrary from '../../helpers/CoreLibrary';
import DropdownMenuFilter from "./DropdownMenuFilter";
import MultiSelectFilter from "./MultiSelectFilter";

import * as actions from "../../../app/Config/ApiUrl";

export default {
    name: "AppFilter",
    extends: coreLibrary,
    components: {
        DropDownFilter,
        DropdownMenuFilter,
        MultiSelectFilter
    },
    props: {
        tableId: String,
        filters: {
            required: true,
            type: Array,
        },
        allFilterValues: {
            type: Object
        },
        searchValue: String,
        timelineStates: {
            type: Array
        },
    },
    data() {
        return {
            filterValues: {},
            filterJob: 0,
            filterTimelineState: 0,
            filterResidence: 0,
            timelineCandidates: {},
            onboardingSiteId: 0,
            timelineStateId: 7,

            options: {
                currentMainTab: 0,
                mainTabs: [
                    {page: actions.DATATABLE_ONBOARDING_URL, pageName: this.$t('people')},
                    {page: actions.DATATABLE_ONBOARDING_CHECKLIST_URL, pageName: this.$t('my_tasks'), className:'guide-step-onboarding-2'},
                    {page: actions.SITE_ONBOARDING_URL, pageName: this.$t('onboarding_site'), condition: true, className: 'guide-step-onboarding-1'},
                    {page: '../onboarding/document/', pageName: this.$t('documents'),className:'guide-step-checklist-4'},
                ],
            }
        }
    },
    computed: {
        filterComputed() {
            let keys = [];
            this.filters.map(i => {
                let k, t, v;
                k = _.snakeCase(_.lowerCase(i.key));
                t = _.kebabCase(_.lowerCase(i.type));
                v = {'title': i.title, 'key': k, 'type': t};
                if (i.option) {
                    v['option'] = i.option;
                }

                if (!this.isUndefined(i.active) || !this.isUndefined(i.initValue)) {
                    v['active'] = i.active || i.initValue;
                }

                if (i.header) {
                    v['header'] = i.header
                }

                if (i.listValueField) {
                    v['listValueField'] = i.listValueField;
                }

                if(i.buttonLabel) v['buttonLabel'] = i.buttonLabel



                keys.push(v)
            });
            return keys;

        },

    },
    methods: {

        /**
         * Onboarding button (based on advanced filter values)
         * */

        store(v) {
            this.filterValues[v.key] = v.value;
            this.$emit('get-values', this.filterValues);

            if(v.key == 'filter_with_job'){
                this.filterJob = v.value;
            }

            if(v.key == 'filter_with_timeline_state'){
                this.filterTimelineState = v.value;
            }


        },

        /**
         * Timeline (based on basic and advanced filters values)
         * */

        getCandidateNumbers() {
            // Filters needs to be unmodified for so we need to create a copy of its value and than iterate over it anr remove filter_with_timeline_state
            let timelineFilters = JSON.parse(JSON.stringify(this.allFilterValues)); 

            if(timelineFilters){
                let i = 0;
                Object.keys(timelineFilters).forEach(function(key, index) {
                    if (key == 'employement_date_range' || key == 'date' || key == 'salary_range') {
                        timelineFilters[key] = JSON.stringify(timelineFilters[key]);
                    } else if (key == 'filter_with_timeline_state') {
                        timelineFilters[key] = null;
                    }
                    i++;
                });
            }

            if(this.searchValue){
                timelineFilters["search"] = this.searchValue;
            }            

            let timelineReqData = {};
            timelineReqData.params = timelineFilters;

            this.axiosGet("admin/app/candidates-total", timelineReqData).then(response => {
                this.timelineCandidates = response.data;
            });

        },
        getOnboardingSite() {

            this.filterJob = this.allFilterValues.filter_with_job;

            this.axiosGet('admin/app/onboardingsite?job='+this.filterJob+'&timeline_state='+this.filterTimelineState).then(response => {

                if(response.data.length !== 0){
                    this.onboardingSiteId = response.data[0].id;
                } else {
                    this.timelineStateId = parseInt(this.allFilterValues.filter_with_timeline_state);
                }

            });
        },

    },
    created() {
        this.getCandidateNumbers();
    },
    mounted() {
        this.$hub.$on('clearAllFilter-' + this.tableId, () => {
            this.filterValues = {};
            this.filterJob = jobFilter.initValue;

            console.log('clear all filters');

        });

        this.$hub.$on('reload-' + this.tableId, () => {
            console.log('reloading table');
            // @todo: get timeline candidates count only after bulk edit?

            // Change of timeline_state, job (and other filters and bulk actions)
            this.getCandidateNumbers();

        });

        if(this.tableId == 'talentpool'){
            this.defaultStatus = 1;
        } else if(this.tableId == 'hiring'){
            this.defaultStatus = 2;
        } else if (this.tableId == 'onboarding'){
            this.defaultStatus = 3;
        }

        if(this.filterTimelineState){
            let timelineFilter = this.filters.find(o => o.key === 'filter-with-timeline-state');
            this.filterTimelineState = timelineFilter.initValue;
        }

    },
}
</script>
